export function getCountryFromLocale(locale: string): string {
  const country = locale.split('-')[1]
  return country ?? ''
}

/**
 * Function to get the language path segment based on the culture.
 *
 * @param {string} culture current culture for getting the language path segment.
 * @returns The path for multi-language locale.
 */
export const getPathFromCulture = (culture: string): string => {
  switch (culture.toLowerCase()) {
    case 'fr-be':
    case 'fr-ca':
    case 'fr-ch':
      return '/fr'
    case 'es-us':
      return '/es'
    case 'it-ch':
      return '/it'
    default:
      return ''
  }
}
